<script>
import CargoElInput from '@/components/Cargo/Common/cargoElInput'

const SBC_CASE = ['，', '。', '–', '、', '‘', '’', '“', '”', '；', '×', '￥', '·', '！', '＃', '＄', '％', '＆', '＇', '（', '）', '＊', '＋', '，', '－', '／',
  '０', '１', '２', '３', '４', '５', '６', '７', '８', '９', '：', '；', '＜', '＝', '＞', '？', '＠', 'Ａ', 'Ｂ', 'Ｃ', 'Ｄ', 'Ｅ', 'Ｆ', 'Ｇ', 'Ｈ', 'Ｉ', 'Ｊ', 'Ｋ', 'Ｌ', 'Ｍ', 'Ｎ', 'Ｏ', 'Ｐ',
  'Ｑ', 'Ｒ', 'Ｓ', 'Ｔ', 'Ｕ', 'Ｖ', 'Ｗ', 'Ｘ', 'Ｙ', 'Ｚ', '［', '］', '＾', '＿', '｀', 'ａ', 'ｂ', 'ｃ', 'ｄ', 'ｅ', 'ｆ', 'ｇ', 'ｈ', 'ｉ', 'ｊ', 'ｋ', 'ｌ', 'ｍ', 'ｎ', 'ｏ', 'ｐ', 'ｑ', 'ｒ',
  'ｓ', 'ｔ', 'ｕ', 'ｖ', 'ｗ', 'ｘ', 'ｙ', 'ｚ', '｛', '｜', '｝', '～', '　', ' ']

/**
 * 半角字符
 */
const DBC_CASE = [',', '.', '-', '/', "'", "'", '"', '"', ';', '*', '$', '`', '!', '#', '$', '%', '&', '"', '(', ')', '*', '+', ',', '-', '/', '0', '1', '2', '3',
  '4', '5', '6', '7', '8', '9', ':', ';', '<', '=', '>', '?', '@', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '[',
  ']', '^', '_', '`', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '{', '|', '}', '~', ' ', ' ']

export default {
  name: 'CargoTextarea',
  extends: CargoElInput,
  props: {
    wrapSymbol: { type: String, default: 'n' },
    autoHalfWord: { type: Boolean, default: () => false }, // 是否自动转全角
    autoUppercase: { type: Boolean, default: () => false }, // 是否自动大写
    englishLetterAutoUppercase: { type: Boolean, default: () => false } // 字母是否自动转大写
  },
  methods: {
    handleInput(event) {
      // should not emit input during composition
      // see: https://github.com/ElemeFE/element/issues/10516
      if (this.isComposing) return

      const pattern = new RegExp("['\"]", 'g')
      if (this.filterChars && pattern.test(event.target.value)) {
        console.log('-----filter-textarea-----', event)
        event.target.value = event.target.value.replaceAll(pattern, '')
      }

      event.target.value = event.target.value.replace(/(\r\n)|(\n)|(\r)/g, this.wrapSymbol === 'n' ? '\n' : '\r')

      if (this.autoHalfWord) {
        event.target.value = this.toCDB(event.target.value)
      }

      if (this.autoUppercase) {
        event.target.value = event.target.value.toUpperCase()
      }

      // hack for https://github.com/ElemeFE/element/issues/8548
      // should remove the following line when we don't support IE
      if (event.target.value === this.nativeInputValue) return

      this.$emit('input', event.target.value)

      // ensure native input value is controlled
      // see: https://github.com/ElemeFE/element/issues/12850
      this.$nextTick(this.setNativeInputValue)
    },
    toCDB(str) {
      if (str) {
        for (let i = 0; i < SBC_CASE.length; i++) {
          const reg = new RegExp(SBC_CASE[i], 'g')
          str = str.replace(reg, DBC_CASE[i])
        }
      }
      return str
    },
    hanldeFormat() {
      if (this.value === '') return
      if (this.value.endsWith('\r') || this.value.endsWith('\n')) {
        const newValue = this.value.substring(0, this.value.length - 1)
        this.$emit('input', newValue)
        this.$emit('change', newValue)
      }
    }
  }
}
</script>
